import { Injectable } from '@angular/core';
import { RouterStateSnapshot } from '@angular/router';

import { AuthService } from '@app/api/api-services/auth.service';
import { RouteHelperService } from '../route-helper.service';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class RedirectEidGuard {
  constructor(
    private readonly authService: AuthService,
    private readonly routeHelper: RouteHelperService,
    private readonly cookieService: CookieService
  ) {}

  public canActivate(state: RouterStateSnapshot): boolean {
    function hasLoginRoute(route): boolean {
      if (route.routeConfig?.path?.includes('login')) {
        return true;
      }
      return route.children?.some(hasLoginRoute) ?? false;
    }

    if (hasLoginRoute(state.root)) {
      return true;
    }
    const hasPreviousEidSession = this.cookieService.get('eidSession');
    if (!hasPreviousEidSession) {
      return true;
    }
    if (!this.authService.isAuthenticated()) {
      this.routeHelper.login(true);
      return false;
    }
    return true;
  }
}
